import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    StatisticsCompany, StatisticsGroup,
    StatisticsItem,
    StatisticsPagination,
    StatisticsResponse
} from "features/model/types/hr/getStatistics";


export interface IStatisticsResponse {
    success: boolean;
    isLoading:boolean;
    data: {
        count: number;
        groups:StatisticsGroup[];
        company: StatisticsCompany;
        items: StatisticsItem[];
        pagination: StatisticsPagination;
    };
}


const initialState: IStatisticsResponse = {
    success: false,
    isLoading: true,
    data: {
        groups: [],
        count: 0,
        company: { id: 0, title: '' },
        items: [],
        pagination: { page: 0, pageSize: 0, pageCount: 0 },
    },
};


const statisticsSlice = createSlice({
    name: 'statistics',
    initialState,
    reducers: {
        setStatisticsData: (state, action: PayloadAction<StatisticsResponse['data']>) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});


export const { setStatisticsData, setLoading } = statisticsSlice.actions;
export const statisticsReducer = statisticsSlice.reducer;
